import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import useMessage from "hooks/useMessage";
import ToolTip from "components/ToolTip/ToolTip";
import IconButton from "components/IconButton/IconButton";
import { TenantManager as manager } from "managers";
import { CompaniaManager, SolicitudCompaniaTenantManager as SolicitudManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import { DateHelper, DEFAULT_PAGINATION_VALUES, FORMAS_PAGO, ESTATUS_TERMINAL } from "utils";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import { CompaniaVinculada } from "models/ECF/CompaniaVinculada";
import { useAuthentication } from "hooks";
import ModalContainer from "components/ModalContainer/ModalContainer";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import ListHeader from "components/PantallaList/Header/ListHeader";
import { EditSection } from "components/MiCuenta/EditSection/EditSection";
import { Form, Row } from "react-bootstrap";
import { Permisos } from "utils/permisos";
import { Compania } from "models/Compania";
import { TIPO_SOLICITUD_CANCELACION, TIPO_SOLICITUD_ACTIVACION, TIPO_SOLICITUD_REACTIVACION } from "models/SolicitudesCompaniaTenant"

import Select from "react-select";
import uuid from "react-uuid";

import {
  GridView,
  InputSidebarContainer,
  SvgComponent,
  Simplebar,
} from "components";
import Exportar from "components/Exportar/Exportar";
import ReporteViewer from "components/Reportes/ReporteViewer";

const ESTATUS_COMPANIA_LIST = [{ value: "", label: "Todos" }, ...Compania.ESTATUS_LIST];

const ESTATUS_BLOQUEAR_LIST = [
  { value: "I", label: "Inactiva" },
  { value: "B", label: "Bloqueada" }
];

const TIPO_REPORTE_COMERCIO = "1";
const TIPO_REPORTE_COMERCIO_LABEL = "Reporte Comercios/Empresas (RNC)";
const TIPO_REPORTE_TERMINAL = "2";
const TIPO_REPORTE_TERMINAL_LABEL = "Reporte de Terminales";
const TIPO_REPORTE_TRANSACCION = "3";
const TIPO_REPORTE_TRANSACCION_LABEL = "Reporte de Transacciones";

const ESTATUS_TRANSACCION_LIST = [
  { value: "N", label: "Pendiente Envio" },
  { value: "P", label: "En Proceso" },
  { value: "I", label: "Error Interno" },
  { value: "T", label: "Terminada" }
];

const ESTADO_ECF_LIST = [
  { value: "A", label: "Aceptado" },
  { value: "C", label: "Aceptado Condicional" },
  { value: "R", label: "Rechazado" },
  { value: "P", label: "En Proceso" }
];

const FORMATO_REPORTE = [
  { value: "PDF", label: "PDF" },
  { value: "Excel", label: "Excel" },
  { value: "CSV", label: "CSV" },
  { value: "TSV", label: "TSV" },
  { value: "JSON", label: "JSON" }
];

export default function CompaniaVinculadaList({ showLoading, hideLoading }) {
  const getLastMonthRange = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();

    const firstDay = new Date(currentYear, currentMonth - 1, 1);
    firstDay.setHours(0, 0, 0, 0);
    const lastDay = new Date(currentYear, currentMonth, 0);
    lastDay.setHours(23, 59, 59, 0);

    return {
      fechaInicio: firstDay,
      fechaFin: lastDay
    };
  };

  const { usuario, tienePermiso } = useAuthentication();

  const TIPO_REPORTE_LIST = [
    { value: TIPO_REPORTE_COMERCIO, label: TIPO_REPORTE_COMERCIO_LABEL, visible: tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_COMERCIOS) },
    { value: TIPO_REPORTE_TERMINAL, label: TIPO_REPORTE_TERMINAL_LABEL, visible: tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_TERMINALES) },
    { value: TIPO_REPORTE_TRANSACCION, label: TIPO_REPORTE_TRANSACCION_LABEL, visible: tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_TRANSACCIONES) }
  ].filter(item => item.visible);

  const [where, setWhere] = useState(() => {
    const defaultDates = getLastMonthRange();

    return {
      RangoFechas: {
        fechaInicio: defaultDates.fechaInicio,
        fechaFin: defaultDates.fechaFin
      }
    };
  });
  const [reporteWhere, setReporteWhere] = useState({
    TipoReporte: TIPO_REPORTE_LIST[0]?.value,
    FormatoReporte: FORMATO_REPORTE[0].value
  });
  const [list, setList] = useState([]);
  const history = useHistory();
  const [currentCompania, setCurrentCompania] = useState({});
  const [fechaTransaccionFilterkey, setFechaTransaccionFilterkey] = useState(uuid());
  const [fechaRegistroFilterKey, setFechaRegistroFilterKey] = useState(uuid());
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas, Message, Warning } = useMessage();
  const [companiaTenant, setCompaniaTenant] = useState([]);
  const [showBloquearModal, setShowBloquearModal] = useState(false);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [showExportar, setShowExportar] = useState(false);
  const [statusCode, setStatusCode] = useState();
  const [razonCancelacion, setRazonCancelacion] = useState();
  const [showCanvasFiltrosReporte, setShowCanvasFiltrosReporte] = useState(false);
  const [companiasHijas, setCompaniasHijas] = useState([]);
  const [reporte, setReporte] = useState(undefined);
  const [showCanvasReporte, setShowCanvasReporte] = useState(false);
  const ref = useRef(null);

  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  useEffect(() => {
    buscar();
    return () => {
      cargarCompania();
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  function buscar() {
    const whereWithPaginationValues = {
      ...where,
      ...pagination,
      FechaTransaccionInicio: where.RangoFechas?.fechaInicio,
      FechaTransaccionFin: where.RangoFechas?.fechaFin,
      FechaCreacionInicio: where.RangoFechasCreacion?.fechaInicio,
      FechaCreacionFin: where.RangoFechasCreacion?.fechaFin
    };

    manager
      .listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        try {
          for (let transaccion of res.Data) {
            transaccion["FechaTransaccionInicio"] = DateHelper.formatStringDate(
              transaccion["FechaTransaccionInicio"],
              false
            );
            transaccion["FechaTransaccionFin"] = DateHelper.formatStringDate(
              transaccion["FechaTransaccionFin"],
              false
            );
            transaccion["FechaCreacion"] = DateHelper.formatStringDate(
              transaccion["FechaCreacion"],
              false
            );
          }
        } catch (err) { }
        setList(res.Data);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());

    const companiasHijasWhere = {
      CompaniaTenantId: usuario.CompaniaId
    };

    CompaniaManager.listarHijas(companiasHijasWhere)
      .then((res) => {
        const companiasHijas = res.Data?.map((cia) => {
          return {
            label: `${cia.RNC} - ${cia.Nombre}`,
            value: cia.Id
          };
        });
        setCompaniasHijas(companiasHijas);
      })
      .catch((err) => handleException(err));
  }

  const cargarCompania = () => {
    CompaniaManager.buscarPorId(usuario.CompaniaId)
      .then((data) => {
        setCompaniaTenant(data);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const handleClickCrearCiaVinculada = (params) => {
    const { Id } = params;
    let urlBase = `/CompaniaVinculadaEdit?`;
    if (Id) {
      urlBase += `Id=${Id}`;
    }
    history.push(urlBase);
  };

  const bloquearCancelarCompania = (statusCode, companiaId) => {
    showLoading();

    if (statusCode == ESTATUS_BLOQUEAR_LIST[0].value) {
      SolicitudManager
        .bloquearCancelarCompania({
          TipoSolicitud: TIPO_SOLICITUD_CANCELACION,
          SolicitudCompaniaId: currentCompania.Id,
          RazonCancelacion: razonCancelacion
        })
        .then((res) => {
          Message({ message: "Solicitud de cancelación creada exitosamente." })
        })
        .catch((err) => {
          handleException(err);
        })
        .finally(() => {
          hideLoading();
          setShowBloquearModal(false);
          setStatusCode();
          setRazonCancelacion();
          buscar();
        });
    }
    else {
      CompaniaManager
        .bloquearCancelarCompania({
          Id: companiaId,
          statusCode: statusCode
        })
        .then((res) => {
          Message({ message: "Compañía actualizada exitosamente." })
        })
        .catch((err) => {
          handleException(err);
        })
        .finally(() => {
          hideLoading();
          setShowBloquearModal(false);
          buscar();
        });
    }
  };

  const handleClick = (params) => {
    const { Id } = params;
    const { EsBloquear } = params;
    const reporteTransaccion = list.find((t) => t.Id == Id);

    if (reporteTransaccion !== undefined) {
      setCurrentCompania({
        ...reporteTransaccion
      });

      if (EsBloquear) {
        if (reporteTransaccion.Estatus == ESTATUS_COMPANIA_LIST[3].label) {
          Warning({
            message: `La Compañía se encuentra bloqueada.`
          });
          return;
        }

        if (companiaTenant.Estatus == ESTATUS_COMPANIA_LIST[2].label) {
          Warning({
            message: `La Compañía se encuentra inactiva.`
          });
          return;
        }

        setShowBloquearModal(true);
      }
      else {
        if (reporteTransaccion.Estatus == ESTATUS_COMPANIA_LIST[1].label) {
          Message({
            message: `La Compañía se encuentra activa.`
          });
          return;
        }

        showLoading();

        SolicitudManager
          .reactivarCompaniVinculada({
            TipoSolicitud: TIPO_SOLICITUD_REACTIVACION,
            SolicitudCompaniaId: reporteTransaccion.Id
          })
          .then((res) => {
            Message({ message: "Solicitud de re-activación creada exitosamente." })
          })
          .catch((err) => {
            handleException(err);
          })
          .finally(() => {
            hideLoading();
            buscar();
          });
      }
    }
  };

  const handleRequestsClick = () => {
    let urlBase = `/SolicitudCompaniaTenantList?t=true`;
    history.push(urlBase);
  }

  const onReset = () => {
    setFechaTransaccionFilterkey(uuid());
    setFechaRegistroFilterKey(uuid());
  };

  const openExportar = () => {
    setShowExportar(true);
  };

  const openReporteSideBar = () => {
    setShowCanvasFiltrosReporte(true);
  };

  const imprimirReporte = () => {
    showLoading();
    if (reporteWhere.FormatoReporte === FORMATO_REPORTE[0].value) {
      manager
        .reporte(reporteWhere)
        .then((res) => {
          setReporte(res.Data);
          setShowCanvasReporte(true);
        })
        .catch((err) => handleException(err))
        .finally(() => hideLoading());
    }
    else {
      let extension = "csv";
      switch (reporteWhere.FormatoReporte) {
        case "Excel":
          extension = "xls";
          break;
        case "CSV":
          extension = "csv";
          break;
        case "TSV":
          extension = "tsv";
          break;
        case "JSON":
          extension = "json";
          break;
      }
      manager
        .reporteText(reporteWhere)
        .then(async (res) => {
          const link = document.createElement("a");
          const result = await res.blob;
          link.target = "_blank";
          link.download = `${uuid()}.${extension}`;
          link.href = URL.createObjectURL(result);
          link.click();
        })
        .catch((err) => handleException(err))
        .finally(() => hideLoading());
    }
  };

  const FilterSimplebar = () => {
    const renderConditionalFilters = () => {
      switch (reporteWhere.TipoReporte) {
        case TIPO_REPORTE_COMERCIO:
          return (
            <>
              <InputSidebarContainer label="Compañías">
                <Select
                  className="react-select primary mb-2"
                  classNamePrefix="react-select"
                  name="CompaniaHijasListId"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      CompaniaHijasListId: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={companiasHijas}
                  value={companiasHijas.filter(function (option) {
                    return reporteWhere?.CompaniaHijasListId?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Rango de Fechas de Registro">
                <DateTimePicker
                  soloFecha
                  usarLabel={false}
                  esRangoFechas={true}
                  labelFechaInicio="Desde"
                  labelFechaFin="Hasta"
                  fechaInicioOriginal={reporteWhere.FechaRegistroInicio}
                  fechaFinOriginal={reporteWhere.FechaRegistroFin}
                  onChange={(e) => {
                    if (
                      (reporteWhere.FechaRegistroInicio !==
                        DateHelper.formatDate(e.fechaInicio) ||
                        reporteWhere.FechaRegistroFin !==
                        DateHelper.formatDate(e.fechaFin)) &&
                      (e.fechaFin || e.fechaInicio)
                    ) {
                      setReporteWhere({
                        ...reporteWhere,
                        FechaRegistroInicio: DateHelper.formatDate(e.fechaInicio),
                        FechaRegistroFin: DateHelper.formatDate(e.fechaFin)
                      });
                    }
                  }}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Estatus">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="EstatusList"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      EstatusList: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={Compania.ESTATUS_LIST}
                  value={Compania.ESTATUS_LIST.filter(function (option) {
                    return reporteWhere?.EstatusList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>
            </>
          );

        case TIPO_REPORTE_TERMINAL:
          return (
            <>
              <InputSidebarContainer label="Compañías">
                <Select
                  className="react-select primary mb-2"
                  classNamePrefix="react-select"
                  name="CompaniaHijasListId"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      CompaniaHijasListId: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={companiasHijas}
                  value={companiasHijas.filter(function (option) {
                    return reporteWhere?.CompaniaHijasListId?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Rango de Fechas de Registro">
                <DateTimePicker
                  soloFecha
                  usarLabel={false}
                  esRangoFechas={true}
                  labelFechaInicio="Desde"
                  labelFechaFin="Hasta"
                  fechaInicioOriginal={reporteWhere.FechaRegistroInicio}
                  fechaFinOriginal={reporteWhere.FechaRegistroFin}
                  onChange={(e) => {
                    if (
                      (reporteWhere.FechaRegistroInicio !==
                        DateHelper.formatDate(e.fechaInicio) ||
                        reporteWhere.FechaRegistroFin !==
                        DateHelper.formatDate(e.fechaFin)) &&
                      (e.fechaFin || e.fechaInicio)
                    ) {
                      setReporteWhere({
                        ...reporteWhere,
                        FechaRegistroInicio: DateHelper.formatDate(e.fechaInicio),
                        FechaRegistroFin: DateHelper.formatDate(e.fechaFin)
                      });
                    }
                  }}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Estatus Terminal">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="EstatusTerminalList"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      EstatusTerminalList: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={ESTATUS_TERMINAL}
                  value={ESTATUS_TERMINAL.filter(function (option) {
                    return reporteWhere?.EstatusTerminalList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>
            </>
          );

        case TIPO_REPORTE_TRANSACCION:
          return (
            <>
              <InputSidebarContainer label="Compañías">
                <Select
                  className="react-select primary mb-2"
                  classNamePrefix="react-select"
                  name="CompaniaHijasListId"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      CompaniaHijasListId: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={companiasHijas}
                  value={companiasHijas.filter(function (option) {
                    return reporteWhere?.CompaniaHijasListId?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Rango de Fechas de Transacción">
                <DateTimePicker
                  soloFecha
                  usarLabel={false}
                  esRangoFechas={true}
                  labelFechaInicio="Desde"
                  labelFechaFin="Hasta"
                  fechaInicioOriginal={reporteWhere.FechaTransaccionInicio}
                  fechaFinOriginal={reporteWhere.FechaTransaccionFin}
                  onChange={(e) => {
                    if (
                      (reporteWhere.FechaTransaccionInicio !==
                        DateHelper.formatDate(e.fechaInicio) ||
                        reporteWhere.FechaTransaccionFin !==
                        DateHelper.formatDate(e.fechaFin)) &&
                      (e.fechaFin || e.fechaInicio)
                    ) {
                      setReporteWhere({
                        ...reporteWhere,
                        FechaTransaccionInicio: DateHelper.formatDate(e.fechaInicio),
                        FechaTransaccionFin: DateHelper.formatDate(e.fechaFin)
                      });
                    }
                  }}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Método de Pago">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="FormaPagoList"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      FormaPagoList: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={FORMAS_PAGO}
                  value={FORMAS_PAGO.filter(function (option) {
                    return reporteWhere?.FormaPagoList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Estatus Transacción">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="EstatusTransaccionList"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      EstatusTransaccionList: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={ESTATUS_TRANSACCION_LIST}
                  value={ESTATUS_TRANSACCION_LIST.filter(function (option) {
                    return reporteWhere?.EstatusTransaccionList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Estado e-CF">
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="EstadoECFList"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      EstadoECFList: e ? e.map((option) => option.value) : null
                    });
                  }}
                  options={ESTADO_ECF_LIST}
                  value={ESTADO_ECF_LIST.filter(function (option) {
                    return reporteWhere?.EstadoECFList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>
            </>
          );
      }
    };

    return (
      <Simplebar
        ref={ref}
        backdrop={true}
        placement={"end"}
        portal={false}
        visible={showCanvasFiltrosReporte}
        setShow={(e) => {
          setShowCanvasFiltrosReporte(e);
        }}
        useLoading={true}
        title="Filtros Reporte de Compañías"
        size="lg"
        btnLeft={{
          show: false
        }}
        btnRight={{
          show: true,
          message: "Imprimir",
          isComponent: true,
          size: "45px",
          height: "24px",
          width: "24px",
          iconName: "check",
          func: () => {
            imprimirReporte();
            setShowCanvasFiltrosReporte(false);
          }
        }}
      >
        <InputSidebarContainer label="Tipo de Reporte">
          <Select
            className="react-select primary mb-2"
            classNamePrefix="react-select"
            name="TipoReporte"
            onChange={(e) => {
              setReporteWhere({
                ...reporteWhere,
                TipoReporte: e.value
              });
            }}
            options={TIPO_REPORTE_LIST}
            value={TIPO_REPORTE_LIST.filter(function (option) {
              return (
                option.value ===
                (reporteWhere.TipoReporte
                  ? reporteWhere.TipoReporte
                  : TIPO_REPORTE_LIST[0].value
                )
              );
            })}
          />
        </InputSidebarContainer>

        {renderConditionalFilters()}

        <InputSidebarContainer
          label="Formato del Reporte"
          style={{ display: "flex", justifyContent: "flex-start" }}
        >
          <RadioGroup
            options={FORMATO_REPORTE}
            selectedOption={reporteWhere.FormatoReporte}
            onChange={(e) => {
              setReporteWhere({
                ...reporteWhere,
                FormatoReporte: e.target.value,
              });
            }}
          />
        </InputSidebarContainer>
      </Simplebar>
    );
  };

  const RadioGroup = ({ options, selectedOption, onChange }) => {
    return (
      <div>
        {options.map((option) => (
          <label key={option.value} style={{ fontWeight: "none !important" }}>
            <input
              style={{ marginLeft: "5px" }}
              type="radio"
              value={option.value}
              checked={selectedOption === option.value}
              onChange={onChange}
            />
            {option.label}
          </label>
        ))}
      </div>
    );
  };

  const bloquearModal = (
    <ModalContainer
      showModal={showBloquearModal}
      size="lg"
      title={`Bloquear/Inactivar Compañía: ${currentCompania.Id}`}
      subtitle={`${currentCompania.Codigo} - ${currentCompania.Nombre}`}
      btnGrabar={{
        label: "Grabar",
        show: true
      }}
      cerrar={() => {
        setShowBloquearModal(false);
      }}
      grabar={() => {
        bloquearCancelarCompania(statusCode, currentCompania.Id);
      }}
    >
      <EditSection>
        <Row>
          <InputSidebarContainer label="Estatus">
            <Select
              className="react-select primary"
              options={ESTATUS_BLOQUEAR_LIST}
              value={ESTATUS_BLOQUEAR_LIST.filter(function (option) {
                return (
                  option.value === statusCode
                );
              })}
              name="Estatus"
              onChange={(e) =>
                setStatusCode(e.value)
              }
            />
          </InputSidebarContainer>
        </Row>
        {statusCode == ESTATUS_BLOQUEAR_LIST[0].value && (
          <Row>
            <InputSidebarContainer label="Razón de Cancelación">
              <Form.Control
                as="textarea"
                rows={5}
                style={{ resize: "vertical" }}
                disabled={false}
                value={razonCancelacion}
                onChange={(e) =>
                  setRazonCancelacion(e.target.value)
                }
              >
              </Form.Control>
            </InputSidebarContainer>
          </Row>
        )}
      </EditSection>
    </ModalContainer>
  );

  return (
    <>
      {showBloquearModal && bloquearModal}
      <Exportar
        PROPIEDADES_EXPORTAR={CompaniaVinculada.PROPIEDADES_EXPORTAR}
        showExportar={showExportar}
        setShowExportar={setShowExportar}
        showLoading={showLoading}
        hideLoading={hideLoading}
        where={where}
        exportarCallBack={manager.exportar}
      ></Exportar>

      <FilterSimplebar />

      <ListHeader
        titulo="Compañías Vinculadas"
        exportar={openExportar}
        {...((tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_COMERCIOS) || tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_TERMINALES)
          || tienePermiso(Permisos.ReportesCompaniasVinculadas.LISTAR_TRANSACCIONES)) && { reporte: openReporteSideBar })}
        {...((tienePermiso(Permisos.Compania.CREAR_VINCULADA)) && { crearNuevo: handleClickCrearCiaVinculada })}
        {...(tienePermiso(Permisos.SolicitudTenant.LISTAR) && { requests: handleRequestsClick })}
      />

      <ReporteViewer
        showCanvas={showCanvasReporte}
        setShowCanvas={setShowCanvasReporte}
        reporte={reporte}
      >
      </ReporteViewer>

      <GridView
        dataSource={list}
        where={where}
        setWhere={setWhere}
        setPagination={setPagination}
        onPageIndexChanging={onPageIndexChanging}
        pagination={pagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        onReset={onReset}
        height="78vh"
      >
        <GridView.Column
          isField
          width="100px"
          showClearFilter={true}
          bodyRenderer={(row) => {
            return (
              <>
                {tienePermiso(Permisos.Compania.BLOQUEAR) && (
                  <div className="float-right">
                    <IconButton
                      onClick={() => {
                        const esBloquear = row.Estatus == ESTATUS_COMPANIA_LIST[1].label
                        handleClick({
                          Id: row.Id,
                          EsBloquear: esBloquear
                        })
                      }}
                    >
                      <ToolTip message={row.Estatus == ESTATUS_COMPANIA_LIST[1].label ? `Bloquear/Inactivar Compañía` : `Activar Compañía`}>
                        <div>
                          {row.Estatus == ESTATUS_COMPANIA_LIST[1].label ? (
                            <SvgComponent
                              iconName="cancel"
                              height="25px"
                              width="25px"
                            />
                          ) : (
                            <SvgComponent
                              iconName="check"
                              height="25px"
                              width="25px"
                            />
                          )}
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div>
                )}
              </>
            );
          }}
        />
        <GridView.Column
          headerText="Id"
          dataField="Id"
          sortExpression="Id"
        />
        <GridView.Column
          headerText="Nombre"
          dataField="Nombre"
          sortExpression="Nombre"
        />
        <GridView.Column
          headerText="Código"
          dataField="Codigo"
          sortExpression="Codigo"
        />
        <GridView.Column
          headerText="RNC"
          dataField="Rnc"
          sortExpression="Rnc"
        />
        <GridView.Column
          date
          hideFilter
          headerText="Fecha de Registro"
          dataField="FechaCreacion"
          sortExpression="FechaCreacion"
          width="220px"
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={fechaRegistroFilterKey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={where?.RangoFechasCreacion?.fechaInicio || ""}
                fechaFinOriginal={where?.RangoFechasCreacion?.fechaFin || ""}
                onChange={(e) => {
                  const updatedRange = { ...e };

                  if (updatedRange.fechaInicio) {
                    const start = new Date(updatedRange.fechaInicio);
                    start.setHours(0, 0, 0, 0);
                    updatedRange.fechaInicio = start;
                  }

                  if (updatedRange.fechaFin) {
                    const end = new Date(updatedRange.fechaFin);
                    end.setHours(23, 59, 59, 0);
                    updatedRange.fechaFin = end;
                  }

                  onInputChange({
                    target: { name: "RangoFechasCreacion", value: updatedRange }
                  })
                }}
              />
            );
          }}
        />
        <GridView.Column
          headerText="Correo"
          dataField="Email"
          sortExpression="Email"
        />
        <GridView.Column
          headerText="Tel. Principal"
          dataField="TelefonoPrincipal"
          sortExpression="TelefonoPrincipal"
          width="150px"
        />
        <GridView.Column
          headerText="Estatus Compañía"
          dataField="Estatus"
          sortExpression="Estatus"
          width="160px"
          filterRenderer={() => {
            return (
              <Select
                className="react-select primary"
                options={ESTATUS_COMPANIA_LIST}
                value={ESTATUS_COMPANIA_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (where.Estatus ? where.Estatus : ESTATUS_COMPANIA_LIST[0].value)
                  );
                })}
                name="Estatus"
                onChange={(e) =>
                  setWhere({
                    ...where,
                    Estatus: e.value
                  })
                }
              />
            );
          }}
        />
        <GridView.Column
          hideFilter
          headerText="Plan de Transacciones"
          dataField="PlanTransacciones"
          sortExpression="PlanTransacciones"
          width="150px"
          bodyRenderer={(row) => (
            <div style={{ textAlign: "center", width: "100%" }}>
              {row.PlanTransacciones ? row.PlanTransacciones.toLocaleString("en-US") : ""}
            </div>
          )}
        />
        <GridView.Column
          date
          hideFilter
          headerText="Rango Fecha Transacciones"
          dataField="RangoFechaTransaccionDesc"
          sortExpression="RangoFechaTransaccionDesc"
          width="230px"
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={fechaTransaccionFilterkey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={where?.RangoFechas?.fechaInicio || ""}
                fechaFinOriginal={where?.RangoFechas?.fechaFin || ""}
                onChange={(e) => {
                  const updatedRange = { ...e };

                  if (updatedRange.fechaInicio) {
                    const start = new Date(updatedRange.fechaInicio);
                    start.setHours(0, 0, 0, 0);
                    updatedRange.fechaInicio = start;
                  }

                  if (updatedRange.fechaFin) {
                    const end = new Date(updatedRange.fechaFin);
                    end.setHours(23, 59, 59, 999);
                    updatedRange.fechaFin = end;
                  }

                  onInputChange({
                    target: { name: "RangoFechas", value: updatedRange },
                  })
                }
                }
              />
            );
          }}
        />
        <GridView.Column
          hideFilter
          headerText="Cantidad de Transacciones"
          dataField="CantidadTransacciones"
          sortExpression="CantidadTransacciones"
          width="150px"
          bodyRenderer={(row) => (
            <div style={{ textAlign: "center", width: "100%" }}>
              {row.CantidadTransacciones.toLocaleString("en-US")}
            </div>
          )}
        />
      </GridView>
    </>
  );
}
